import clsx from "clsx";
import { bool, number, string } from "prop-types";

import classes from "./Meter.module.scss";

const Meter = ({
  barClassName,
  className,
  high = 61,
  id,
  low = 21,
  max = 100,
  optimum = 100,
  progressClassName,
  showEmptyNudge = false,
  showLabel = true,
  size = 12,
  value,
}) => {
  const percentage = max === 0 ? 0 : value / max;
  const width =
    showEmptyNudge && percentage <= 0
      ? `calc(${percentage * 100}% + 5px)`
      : `${percentage * 100}%`;
  const isNullish = value === undefined || value === null;

  return (
    <div
      className={clsx(classes["meter"], className)}
      data-testid="meter"
      style={{ "--meter-size": `${size}px` }}
    >
      <div
        className={clsx(
          classes["meter__bar"],
          {
            [classes["meter__bar--empty"]]: isNullish,
          },
          barClassName
        )}
        id={id}
      >
        <div
          className={clsx(
            classes["meter__bar__progress"],
            {
              [classes["meter__bar__progress--error"]]:
                percentage > 0 && value < low,
              [classes["meter__bar__progress--warning"]]:
                value >= low && value < high,
              [classes["meter__bar__progress--success"]]: value >= high,
            },
            progressClassName
          )}
          style={{
            width,
          }}
        />
      </div>

      {showLabel && (
        <span
          className={clsx(classes["meter__label"], {
            [classes["meter__label--error"]]: value < low,
            [classes["meter__label--warning"]]: value < high,
            [classes["meter__label--success"]]:
              value > high && value <= optimum,
          })}
        >
          {value}/100
        </span>
      )}
    </div>
  );
};

Meter.propTypes = {
  barClassName: string,
  className: string,
  high: number,
  id: string.isRequired,
  low: number,
  max: number,
  progressClassName: string,
  optimum: number,
  showEmptyNudge: bool,
  showLabel: bool,
  size: number,
  value: number,
};

export default Meter;
